import React from "react";
import { TTypeOfCodec } from "../../../../../shared/src/codecs/codec";
import { TGlobalLegalPartialCodec } from "../../../../../domain/codecs/statePartials/GlobalLegalPartial";
import { filterableAttachments } from "../../Simple/CRMEmailAttachment/CRMEmailAttachment";
import { CRMBlock } from "../CRMBlock/CRMBlock/CRMBlock";
import { CRMBlockScrollCacheView } from "../CRMBlock/CRMBlockViews/CRMBlockViews";
import { CRMFileAttachmentsAssignmentView, TAssignmentCommit } from "../CRMFileAttachmentsAssignmentView/CRMFileAttachmentsAssignmentView";

type TGlobalLegalState = TTypeOfCodec<TGlobalLegalPartialCodec>;

export type TFileAttachmentsAssignmentState = Pick<
    TGlobalLegalState,
    | "file_attachments_assignment_is_open"
    | "file_attachments_assignment_email"
    | "file_attachments_assignment_case_id"
    | "file_attachments_assignment_existing_tiles"
>;

type TCRMLegalInboxRightPaneProps = React.PropsWithChildren<{
    assignmentState: TFileAttachmentsAssignmentState;
    onCancel: () => void;
    onCommit: (commit: TAssignmentCommit) => void;
}>;

export const CRMLegalInboxRightPane = (props: TCRMLegalInboxRightPaneProps): JSX.Element => {
    if (!props.assignmentState.file_attachments_assignment_is_open) {
        return <>{props.children}</>;
    }

    const attachments = filterableAttachments(
        props.assignmentState.file_attachments_assignment_email.children.email.attachments,
    );

    return (
        <CRMBlock
            mode="fixed-option"
            fixedOption={{
                icon: "attach",
                title: "File attachments to doc store",
            }}
            optionGroups={[]}
        >
            <CRMBlockScrollCacheView isShowing={true}>
                <CRMFileAttachmentsAssignmentView
                    attachments={attachments}
                    existingTiles={props.assignmentState.file_attachments_assignment_existing_tiles}
                    onCancel={props.onCancel}
                    onCommit={props.onCommit}
                />
            </CRMBlockScrollCacheView>
        </CRMBlock>
    );
};
